module.exports = "/images/lease-expiration.png?227ecd1fc59cc3a90cd1623a902e3116";